// Types pour la section Iridologie

export interface IridologySession {
  id: string;
  user_id: string;
  patient_id: string;
  session_date: string;
  consultation_type: string;
  eye_observed: string;
  
  // Terrain dominant
  terrain_nervous: boolean;
  terrain_digestive: boolean;
  terrain_circulatory: boolean;
  terrain_eliminatory: boolean;
  terrain_mixed: boolean;
  
  // Vitalité
  vitality_level: string | null;
  vitality_comments: string | null;
  
  // Capacités d'adaptation
  adaptation_good: boolean;
  adaptation_stress_sensitivity: boolean;
  adaptation_fatigue: boolean;
  
  // Zones
  sensitivity_zones: string | null;
  support_zones: string | null;
  
  // Signes de surcharge
  overload_digestive: boolean;
  overload_nervous: boolean;
  overload_emotional: boolean;
  overload_eliminatory: boolean;
  overload_circulatory: boolean;
  
  // Axes d'accompagnement
  axis_hygiene: boolean;
  axis_nutrition: boolean;
  axis_plants: boolean;
  axis_stress: boolean;
  axis_seasonal: boolean;
  
  // Observations
  additional_observations: string | null;
  
  // Recommandations
  recommendations: IridologyRecommendation[];
  
  created_at: string;
  updated_at: string;
}

export interface IridologyRecommendation {
  id: string;
  category: string;
  title: string;
  description: string;
  priority: number;
}

export interface IrisPhoto {
  id: string;
  session_id: string;
  user_id: string;
  eye_side: string;
  photo_url: string;
  photo_order: number;
  notes: string | null;
  created_at: string;
}

export interface IridologyFormData {
  patient_id: string;
  session_date: string;
  consultation_type: string;
  eye_observed: string;
  
  // Genre du patient
  patient_gender: 'male' | 'female' | null;
  is_pregnant: boolean;
  is_breastfeeding: boolean;
  
  // Terrain dominant
  terrain_nervous: boolean;
  terrain_digestive: boolean;
  terrain_circulatory: boolean;
  terrain_eliminatory: boolean;
  terrain_mixed: boolean;
  
  // Vitalité
  vitality_level: string | null;
  vitality_comments: string;
  
  // Capacités d'adaptation
  adaptation_good: boolean;
  adaptation_stress_sensitivity: boolean;
  adaptation_fatigue: boolean;
  
  // Zones
  sensitivity_zones: string;
  support_zones: string;
  
  // Signes de surcharge
  overload_digestive: boolean;
  overload_nervous: boolean;
  overload_emotional: boolean;
  overload_eliminatory: boolean;
  overload_circulatory: boolean;
  
  // Axes d'accompagnement
  axis_hygiene: boolean;
  axis_nutrition: boolean;
  axis_plants: boolean;
  axis_stress: boolean;
  axis_seasonal: boolean;
  
  // Observations
  additional_observations: string;
}

export const defaultIridologyFormData: IridologyFormData = {
  patient_id: '',
  session_date: new Date().toISOString().split('T')[0],
  consultation_type: 'iridology_only',
  eye_observed: 'both',
  
  // Genre
  patient_gender: null,
  is_pregnant: false,
  is_breastfeeding: false,
  
  terrain_nervous: false,
  terrain_digestive: false,
  terrain_circulatory: false,
  terrain_eliminatory: false,
  terrain_mixed: false,
  
  vitality_level: null,
  vitality_comments: '',
  
  adaptation_good: false,
  adaptation_stress_sensitivity: false,
  adaptation_fatigue: false,
  
  sensitivity_zones: '',
  support_zones: '',
  
  overload_digestive: false,
  overload_nervous: false,
  overload_emotional: false,
  overload_eliminatory: false,
  overload_circulatory: false,
  
  axis_hygiene: false,
  axis_nutrition: false,
  axis_plants: false,
  axis_stress: false,
  axis_seasonal: false,
  
  additional_observations: '',
};
